
// Calculate total distance between two stations in electric-train routes
export function caldistance(routes, source, destination) {
  for (const routeKey in routes) {
    const stations = routes[routeKey].stations;
    for (const code in stations) {
      if (stations[code].distance_km === undefined) {
        stations[code].distance_km = {};
        for (const nextCode in stations[code].distance_m) {
          if (stations[code].distance_m[nextCode] !== undefined) {
            stations[code].distance_km[nextCode] =
              stations[code].distance_m[nextCode] / 1000;
          }
        }
      }
    }
  }

  //console.log(routes);
  // Build a graph: station code => [{next, distance}]
  const graph = {};
  for (const routeKey in routes) {
    const stations = routes[routeKey].stations;
    for (const code in stations) {
      if (!graph[code]) graph[code] = [];
      const distObj = stations[code].distance_km;
      for (const next in distObj) {
        graph[code].push({ next, distance: distObj[next] });
        // Add reverse edge if not already present (for bidirectional travel)
        if (!graph[next]) graph[next] = [];
        if (!graph[next].some((e) => e.next === code)) {
          // Find reverse distance if exists, else use same
          const revDist = stations[next]?.distance_km?.[code] ?? distObj[next];
          graph[next].push({ next: code, distance: revDist });
        }
      }
    }
  }

  // BFS to find shortest path and sum distances
  const queue = [{ code: source, total: 0, visited: new Set([source]) }];
  while (queue.length) {
    const { code, total, visited } = queue.shift();
    if (code === destination) return total;
    for (const edge of graph[code] || []) {
      if (!visited.has(edge.next)) {
        queue.push({
          code: edge.next,
          total: total + edge.distance,
          visited: new Set([...visited, edge.next]),
        });
      }
    }
  }
  return null;
}

// --- Function to calculate emissions for MenuOne ---
const M = 1000000;
const K = 1000;

// page 2
export function cal_1(data, selectedTrainType, selectedRoadMode, distanceKm) {
  console.log("--- calculateMenuOneEmissions: Start --- calculation.js ---");
  console.log("Input data:", {
    selectedTrainType,
    selectedRoadMode, // road_mode
    distanceKm, //KM
  });
  console.log("Full 'data' object received:", data);
  
  const results = {
    road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
  };

  // distanceKm = KM
  // roadModeData = road_mode

  // Calculate Road Emissions (1.1 และ 1.2)
  let roadModeData = null;
  if(selectedTrainType === "train" )
  {
      roadModeData = data?.emission?.road_modes?.[selectedRoadMode];
  }
  else
  {
      roadModeData = data?.emission?.road_modes_electrictrain?.[selectedRoadMode];
  }
  // console.log("Road Mode Data for '" + selectedRoadMode + "':", roadModeData);

  let calculatedKgPM2 = roadModeData["gPM2.5/km-passegner"];
  console.log("calculatedKgPM2", calculatedKgPM2);

  

  // Table 1.1 type train & e-train = road 
  if (roadModeData && distanceKm > 0) {
    // tCO2  = gCO2/passenger-km(127.1)*distanceKm
    results.road.tCO2 = ((roadModeData['gCO2/km-passegner'] || 0)  * (distanceKm.toFixed(2)));

    // kgPM2.5
    results.road.kgPM2 = ((roadModeData['gPM2.5/km-passegner'] || 0) * (distanceKm.toFixed(2)) * K);

    // kgNOx
    results.road.kgNOx = ((roadModeData['gNOx/km-passegner'] || 0) * (distanceKm.toFixed(2)) * K);
  
    // kgCO
    results.road.kgCO = ((roadModeData['gCO/km-passegner'] || 0 ) * (distanceKm.toFixed(2)) * K);
  }   
  //  else {
  //   console.log("E-Train & Road_mode"); 
  // }

  
  // let train_tfuel = json.emission.train["tfuel/km"] * KM
  let train_tfuel = (data?.emission?.train?.["tfuel/km"] || 0) * (distanceKm.toFixed(2));
 
  console.log("train_tfuel", train_tfuel);

  if (distanceKm > 0) {
    let emissionDataType = selectedTrainType === "train" ? "train" : "electrictrain";
    let trainEmissionData = data?.emission?.[emissionDataType]; // Fetch data dynamically

    console.log("ประเภทรถ : ", emissionDataType);
    console.log("ค่าคงที่ของประเภทก๊าซ : ", trainEmissionData);
    console.log("data", data);
    console.log("Full 'data' object distanceKm:", distanceKm);


    // Table 1.2 type train = train
    if (emissionDataType === "train" && trainEmissionData) {
      
      //let train_gCO2 = json.emission.train[“gCO2/km-passegner”] * KM  
      // train_CO2 
      results.train.tCO2 = ( (trainEmissionData["gCO2/km-passegner"] || 0) * (distanceKm.toFixed(2)) )  ;
      
      // train_PM2.5
      results.train.kgPM2 = (((trainEmissionData["kgPM2.5/tfuel"] || 0) * train_tfuel) / (distanceKm.toFixed(2) * trainEmissionData["passenger/train"])) * M;
      
      // train_NOx  
      results.train.kgNOx =
        (((trainEmissionData["kgNOx/tfuel"] || 0) * train_tfuel) / (distanceKm.toFixed(2) * trainEmissionData["passenger/train"])) * M +0.0011;

      // train_CO  
      results.train.kgCO = (((trainEmissionData["kgCO/tfuel"] || 0) * train_tfuel) / (distanceKm.toFixed(2) * trainEmissionData["passenger/train"])) * M;
    } 
    else 
    {
      // let electrictrain_kWh = json.emission.electrictrain[kWh/km-passenger] * KM
      let electrictrain_kWh = trainEmissionData["kWh/km-passenger"] * distanceKm.toFixed(2);

      // Table 1.2 type e-train = e-train 
      // let electrictrain_gCO2 = json.emission.electrictrain[“gCO2/km-passengner”] * KM 
      results.train.tCO2 = (trainEmissionData["gCO2/km-passegner"] || 0 ) * (distanceKm.toFixed(2));
      // console.log('etrain : ', results.train.tCO2)
      
      //E_train_PM2.5
      // let electrictrain_mgPM25 = ((json.emission.electrictrain[“kgPM2.5/kWh”] * electrictrain_kWh ) + (json.emission.electrictrain[“produce-kgPM2.5/kWh”] * electrictrain_kWh )) * 1M 
      results.train.kgPM2 = ((trainEmissionData["kgPM2.5/kWh"] || 0) * (electrictrain_kWh)) + (trainEmissionData["produce-kgPM2.5/kWh"] * (electrictrain_kWh)) * M;
      
      //E_train_NOx  
      // let electrictrain_mgNOx = ((json.emission.electrictrain[“kgNOx/kWh”] * electrictrain_kWh ) + (json.emission.electrictrain[“produce-kgNox/kWh”] x electrictrain_kWh )) * 1M
      results.train.kgNOx = ((trainEmissionData["kgNOx/kWh"] || 0) * (electrictrain_kWh)) + (trainEmissionData["produce-kgNOx/kWh"] * (electrictrain_kWh)) * M;
     
      //E_train_CO
      //let electrictrain_mgCO = ((json.emission.electrictrain[“kgCO/kWh”] * electrictrain_kWh ) + (json.emission.electrictrain[“produce-kgCO/kWh”] * electrictrain_kWh )) / 1M
      results.train.kgCO = ((trainEmissionData["kgCO/kWh"] || 0) * (electrictrain_kWh)) + (trainEmissionData["produce-kgCO/kWh"] * (electrictrain_kWh)) * M;

      console.log(
        "electrictrain gCO2/km-passegner : ",
        trainEmissionData["gCO2/km-passegner"]
      );
      console.log("electrictrain kgPM2.5/kWh :  ",results.train.kgPM2);
      console.log("electrictrain kgNOx/kWh :  ", results.train.kgNOx);
      console.log("(trainEmissionData['kgNOx/kWh'] :  ", trainEmissionData["kgNOx/kWh"]);
      console.log("(trainEmissionData['produce-kgNOx/kWh'] :  ", trainEmissionData["produce-kgNOx/kWh"]);
      console.log("electrictrain kgCO/kWh :  ", results.train.kgCO);
    }
  }

  // Table 1.3 type road - (train & e-train)  = reduce
  results.reduce.tCO2 = (results.road.tCO2 - results.train.tCO2);
  results.reduce.kgPM2 = (results.road.kgPM2 - results.train.kgPM2);
  results.reduce.kgNOx = (results.road.kgNOx - results.train.kgNOx);
  results.reduce.kgCO = (results.road.kgCO - results.train.kgCO);

  console.log("Calculated results:", results);
  return results;
}

// page 3
export function cal_2(
  data,
  {
    goodsType, // goods_type
    totalWeight, // goods_tonne
    roadDistance, // road_km
    vehicleType, // vehicle_type
    railDistance, // train_Km
    railFuelConsumption, 
    tfuel // ปริมารเชื้อเพลิง  =  train_tfuel = 
  }
) {
  const results = {
    road: { co2: 0, pm25: 0, nox: 0, co: 0 },
    train: { co2: 0, pm25: 0, nox: 0, co: 0 },
    reduction: { co2: 0, pm25: 0, nox: 0, co: 0 },
  };

  console.log("road_gkfuel",road_kgfuel);
  console.log("tfuel...",tfuel)


  // Table 1 Road_Mode
  // let road_KM = input จาก user = roadDistance
  // let road_kgfuel= json.logistics.vehicle_types[vehicle_type][“kgfuel/km”]  * road_KM; 
  let road_kgfuel =  vehicleType["kgfuel/km"] * roadDistance;

  // let road_gCO2 = json.logistics.goods_types[goods_type]["road_gCO2/km-tonne"] * road_KM * goods_tonne 
  let road_gCO2 = goodsType["road_gCO2/km-tonne"] * roadDistance * totalWeight ;
  
  //let road_mgPM25 = (json.logistics.vehicle_types[vehicle_type][“gPM25/km”] * road_kgfuel) / (road_KM x goods_tonne)  * 1M
  let road_mgPM25 = ((vehicleType["gPM2.5/km"] * road_kgfuel) / (roadDistance * totalWeight)) * M; 

  //let road_mgNOX = (json.logistics.vehicle_types[vehicle_type][“gNOX/km”] * road_kgfuel) / (road_KM x goods_tonne) * 1M
  let road_mgNOX =  ((vehicleType["gNOX/km"] * road_kgfuel) / (roadDistance * totalWeight)) * M;
  
  //let road_mgCO  = (json.logistics.vehicle_types[vehicle_type][“gCO/km”] * road_kgfuel) / (road_KM x goods_tonne) * 1M
  let road_mgCO =  ((vehicleType["gCO/km"] * road_kgfuel) / (roadDistance * totalWeight)) * M;
 


  // Table 2 Train_Mode
  // let train_KM = คํานวณระยะทาง จาก สถานทีต ้นทาง-ปลายทาง =  railDistance

  // let train_tfuel_CO2 = goods_tonne x train_KM * json.logistics[“train_fueldensity_t/m3”] * json.logistics[“train_fuelconsumption_lts/km-tonne”] / 1K
  let train_tfuel_CO2 = (totalWeight * railDistance * data.logistics["train_fueldensity_t/m3"] * data.logistics["train_fuelconsumption_lts/km-tonne"]) / K

  //let train_tfuel = json.logistics[“train_tfuel/km”] * train_KM
  let train_tfuel = data.logistics["train_tfuel/km"] * railDistance ;

  //let train_gCO2  = train_tfuel_CO2 * json.logistics[“train_tCO2/tfuel"”] * 1M 
  let train_gCO2 =  train_tfuel_CO2 * data.logistics["train_tCO2/tfuel"] * M;

  //let train_mgPM25 = train_tfuel * json.logistics[train_kgPM2.5/tfuel] / (goods_tonne * train_KM) * 1M
  let train_mgPM25 = ((train_tfuel  *  data.logistics["train_kgPM2.5/tfuel"]) / (totalWeight * railDistance)) * M; 

  //let train_mgNOx   = train_tfuel * json.logistics[train_kgNOx/tfuell] / (goods_tonne  * train_KM)  * 1M
  let train_mgNOx  = ((train_tfuel  *  data.logistics["train_kgNOx/tfuel"]) / (totalWeight * railDistance)) * M;

  //let train_mgCO  = train_tfuel * json.logistics[train_kgCO/tfuell] / (goods_tonne  * train_KM) * 1M
  let train_mgCO  =  ((train_tfuel  *  data.logistics["train_kgCO/tfuel"]) / (totalWeight * railDistance)) * M;

 
  

  // --- Calculations for ROAD Emissions ---
  if (roadDistance > 0) {
    // --- Calculations for Road Emissions ---
    results.road.co2 = road_gCO2;
    results.road.pm25 = road_mgPM25;
    results.road.nox =  road_mgNOX;
    results.road.co = road_mgCO;
  }

  // --- Calculations for RAIL Emissions ---
  if (railDistance > 0) {
    // Assuming rail factors are per tonne-kilometer
    results.train.co2 = train_gCO2;
    results.train.pm25 = train_mgPM25;
    results.train.nox =train_mgNOx;
    results.train.co = train_mgCO;
  }

  // --- Calculate Reduction ---
  results.reduction.co2 = (results.road.co2 - results.train.co2);
  results.reduction.pm25 = (results.road.pm25 - results.train.pm25);
  results.reduction.nox = (results.road.nox - results.train.nox);
  results.reduction.co = (results.road.co - results.train.co);

 
  console.log("Calculated results:", results);
  return results;
}

// page 4
export function cal_3(
  data,
  selectedRoadMode, // road_mode 
  km_passenger_year, // KM_PASSEGER_YEAR 
  electrictrain_kWh_YEAR //electrictrain_kWh_YEAR 
) {
  console.log("Input data for cal_3:", {
    selectedRoadMode,
    km_passenger_year,
    electrictrain_kWh_YEAR,
  });
  console.log("Full 'data' object received by cal_3:", data);

  const results = {
    road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
  };

  // Ensure roadModeData and electrictrain data exist before calculations
  const roadModeData = data?.emission?.road_modes_electrictrain?.[selectedRoadMode];
  const electricTrainData = data?.emission?.electrictrain;

  console.log("Road Mode Data for '" + selectedRoadMode + "':", roadModeData);
  console.log("Electric Train Data:", electricTrainData);
  console.log("km_passenger_year (parsed):", km_passenger_year);
  console.log("electrictrain_kWh_YEAR (parsed):", electrictrain_kWh_YEAR);

  if (
    roadModeData &&
    electricTrainData &&
    km_passenger_year > 0 &&
    electrictrain_kWh_YEAR > 0
  ) {
    // Calculations for Road Emissions
    // let road_tCO2 = emission.road_modes[road_mode ][“gCO2/km-passegner”] * KM_PASSEGER_YEAR / 1M 
    results.road.tCO2 = (roadModeData["gCO2/km-passegner"] * km_passenger_year) / M;

    // let road_kgPM25 = json.emission.road_modes[road_mode ][“gPM2.5/km-passegner”] * KM_PASSEGER_YEAR / 1K
    results.road.kgPM2 = (roadModeData["gPM2.5/km-passegner"] * km_passenger_year) / K;

    // let road_kgNOx = json.emission.road_modes[road_mode ][“gNOx/km-passegner”] * KM_PASSEGER_YEAR / 1K
    results.road.kgNOx = (roadModeData["gNOx/km-passegner"] * km_passenger_year) / K;

    // let road_kgCO = json.emission.road_modes[road_mode ][“gCO/km-passegner”] * KM_PASSEGER_YEAR / 1K 
    results.road.kgCO = (roadModeData["gCO/km-passegner"] * km_passenger_year) / K;

    // Calculations for Electric Train Emissions
    //let electrictrain_tCO2 = json.emission.electrictrain[“tCO2/MWh”] * (electrictrain_kWh_YEAR / 1K)
    results.train.tCO2 = electricTrainData["tCO2/MWh"] * (electrictrain_kWh_YEAR / K);
    
    //let electrictrain_kgPM25 = ((json.emission.electrictrain[“kgPM2.5/kWh”] * electrictrain_kWh_YEAR ) + (json.emission.electrictrain[“produce-kgPM2.5/kWh”] * electrictrain_kWh_YEAR )) 
    results.train.kgPM2 = ((electricTrainData["kgPM2.5/kWh"] * electrictrain_kWh_YEAR) + (electricTrainData["produce-kgPM2.5/kWh"] * electrictrain_kWh_YEAR));

    //let electrictrain_kgNOx = ((json.emission.electrictrain[“kgNOx/kWh”] * electrictrain_kWh_YEAR ) +  (json.emission.electrictrain[“produce-kgNox/kWh”] * electrictrain_kWh_YEAR ))
    results.train.kgNOx = ((electricTrainData["kgNOx/kWh"] * electrictrain_kWh_YEAR) + (electricTrainData["produce-kgNOx/kWh"] * electrictrain_kWh_YEAR));

    //let electrictrain_kgCO = ((json.emission.electrictrain[“kgCO/kWh”] x electrictrain_kWh_YEAR ) + (json.emission.electrictrain[“produce-kgCO/kWh”] * electrictrain_kWh_YEAR ))
    results.train.kgCO = ((electricTrainData["kgCO/kWh"] * electrictrain_kWh_YEAR) + (electricTrainData["produce-kgCO/kWh"] * electrictrain_kWh_YEAR)) ;

    // Calculations for Reduced Emissions
    results.reduce.tCO2 = (results.road.tCO2 - results.train.tCO2);
    results.reduce.kgPM2 = (results.road.kgPM2 - results.train.kgPM2);
    results.reduce.kgNOx = (results.road.kgNOx - results.train.kgNOx);
    results.reduce.kgCO = (results.road.kgCO - results.train.kgCO);
  } 

  console.log("Final calculated results for cal_3:", results);
  return results;
}


// export function cal_3_weight(
//   data,
//   passenger_year, // PASSEGER_YEAR 
//   km_year, // KM_YEAR
//   percent_motorcycle, // percent_motorcycle
//   percent_passenger , // percent_passenger
//   percent_taxi , // percent_taxi
//   percent_tuktuk , // percent_tuktuk
//   percent_pickuptruck , // percent_pickuptruck
//   percent_van , // percent_van
//   percent_bus , // percent_bus
//   //electrictrain_MWh_YEAR 
//   // electrictrain_MWh_YEAR
// ) {
//   console.log("Input data for cal_3:", {
//     passenger_year, // PASSEGER_YEAR 
//     km_year, // KM_YEAR
//     percent_motorcycle, // percent_motorcycle
//     percent_passenger , // percent_passenger
//     percent_taxi , // percent_taxi
//     percent_tuktuk , // percent_tuktuk
//     percent_pickuptruck , // percent_pickuptruck
//     percent_van , // percent_van
//     percent_bus , // percent_bus
//     //electrictrain_MWh_YEAR
//      // electrictrain_MWh_YEAR
//   });
//   console.log("Full 'data' object received by cal_3:", data);

//   const results = {
//     road: { tCO2: 0},
//     train: { tCO2: 0},
//     reduce: { tCO2: 0},
//   };

//   // Ensure roadModeData and electrictrain data exist before calculations
//   const vehicle_types = data?.emission?.vehicle_types;
//   const electricTrainData = data?.emission?.electrictrain;

//   if (
//     vehicle_types, // PASSEGER_YEAR 
//     electricTrainData &&
//     passenger_year > 0 &&
//     km_year > 0 &&
//     electrictrain_MWh_YEAR > 0
//   ) {
//     // Calculations for Road Emissions
//     let road_tCO2_motorcycle = passenger_year * percent_motorcycle * vehicle_types["motorcycle"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_passenger = passenger_year * percent_passenger * vehicle_types["passenger"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_taxi = passenger_year * percent_taxi * vehicle_types["taxi"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_tuktuk = passenger_year * percent_tuktuk * vehicle_types["tuktuk"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_pickuptruck = passenger_year * percent_pickuptruck * vehicle_types["pickuptruck"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_van = passenger_year * percent_van * vehicle_types["van"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_bus = passenger_year * percent_bus * vehicle_types["bus"]["gCO2/km-passegner"] * km_year / 1e6;


//     results.road.tCO2 = road_tCO2_motorcycle + road_tCO2_passenger + road_tCO2_taxi + road_tCO2_tuktuk + road_tCO2_pickuptruck + road_tCO2_van + road_tCO2_bus;
//     results.train.tCO2 =  electricTrainData["tCO2/MWh"] * (electrictrain_MWh_YEAR);
//     results.reduce.tCO2 = (results.road.tCO2 - results.train.tCO2);
//   } 

//   console.log("Final calculated results for cal_3:", results);
//   return results;
// }

// **Start of the cal_3_weight function**
// This is the function you asked to modify.
// export function cal_3_weight(
//   data,
//   passenger_year,
//   km_year,
//   percent_motorcycle,
//   percent_passenger,
//   percent_taxi,
//   percent_tuktuk,
//   percent_pickuptruck,
//   percent_van,
//   percent_bus,
//   electrictrain_MWh_YEAR
// ) {
//   // ✅ Console log the values received directly from the MenuThree component
//   console.log("--- ค่าที่ได้รับจาก MenuThree (ใน cal_3_weight) ---");
//   console.log("passenger_year:", passenger_year);
//   console.log("km_year:", km_year);
//   console.log("percent_motorcycle:", percent_motorcycle);
//   console.log("percent_passenger:", percent_passenger);
//   console.log("percent_taxi:", percent_taxi);
//   console.log("percent_tuktuk:", percent_tuktuk);
//   console.log("percent_pickuptruck:", percent_pickuptruck);
//   console.log("percent_van:", percent_van);
//   console.log("percent_bus:", percent_bus);
//   console.log("electrictrain_MWh_YEAR:", electrictrain_MWh_YEAR);
//   console.log("-------------------------------------------------------");


//   const results = {
//     road: { tCO2: 0 },
//     train: { tCO2: 0 },
//     reduce: { tCO2: 0 },
//   };

//   const vehicle_types = data?.emission?.vehicle_types;
//   const electricTrainData = data?.emission?.electrictrain;

//   if (
//     // vehicle_types &&
//     // electricTrainData &&
//     passenger_year > 0 &&
//     km_year > 0 &&
//     electrictrain_MWh_YEAR > 0
//   ) {
//     // Calculations for Road Emissions
//     let road_tCO2_motorcycle = passenger_year * (percent_motorcycle / 100) * vehicle_types["motorcycle"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_passenger = passenger_year * (percent_passenger / 100) * vehicle_types["passenger"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_taxi = passenger_year * (percent_taxi / 100) * vehicle_types["taxi"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_tuktuk = passenger_year * (percent_tuktuk / 100) * vehicle_types["tuktuk"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_pickuptruck = passenger_year * (percent_pickuptruck / 100) * vehicle_types["pickuptruck"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_van = passenger_year * (percent_van / 100) * vehicle_types["van"]["gCO2/km-passegner"] * km_year / 1e6;
//     let road_tCO2_bus = passenger_year * (percent_bus / 100) * vehicle_types["bus"]["gCO2/km-passegner"] * km_year / 1e6;
    

//     results.road.tCO2 = road_tCO2_motorcycle + road_tCO2_passenger + road_tCO2_taxi + road_tCO2_tuktuk + road_tCO2_pickuptruck + road_tCO2_van + road_tCO2_bus;
//     results.train.tCO2 = electricTrainData["tCO2/MWh"] * electrictrain_MWh_YEAR;
//     results.reduce.tCO2 = results.road.tCO2 - results.train.tCO2;
//   }

//   // ✅ Console log the final result before returning
//   console.log("--- ผลลัพธ์สุดท้ายที่คำนวณได้ (ใน cal_3_weight) ---");
//   console.log("results:", results);
//   console.log("----------------------------------------------------");

//   return results;
// }


export function cal_3_weight(
  data,
  passenger_year,
  km_year,
  percent_motorcycle,
  percent_passenger,
  percent_taxi,
  percent_tuktuk,
  percent_pickuptruck,
  percent_van,
  percent_bus,
  electrictrain_MWh_YEAR
) {
  console.log("--- ค่าที่ได้รับจาก MenuThree (ใน cal_3_weight) ---");
  console.log("passenger_year:", passenger_year);
  console.log("km_year:", km_year);
  console.log("percent_motorcycle:", percent_motorcycle);
  console.log("percent_passenger:", percent_passenger);
  console.log("percent_taxi:", percent_taxi);
  console.log("percent_tuktuk:", percent_tuktuk);
  console.log("percent_pickuptruck:", percent_pickuptruck);
  console.log("percent_van:", percent_van);
  console.log("percent_bus:", percent_bus);
  console.log("electrictrain_MWh_YEAR:", electrictrain_MWh_YEAR);
  console.log("-------------------------------------------------------");

  const results = {
    road: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    train: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
    reduce: { tCO2: 0, kgPM2: 0, kgNOx: 0, kgCO: 0 },
  };

  const vehicle_types = data?.emission?.vehicle_types;
  const electricTrainData = data?.emission?.electrictrain;

  // Added robust data validation to prevent TypeError
  if (
    !vehicle_types || !electricTrainData ||
    passenger_year <= 0 || km_year <= 0 || electrictrain_MWh_YEAR <= 0
  ) {
    console.warn("Input data for calculation is incomplete or invalid. Returning default values.");
    return results;
  }

  // Calculations for Road Emissions (percentages are now divided by 100)
  // const road_tCO2_motorcycle = passenger_year * (percent_motorcycle / 100) * vehicle_types["motorcycle"]["gCO2/km-passegner"] * km_year / 1e6;
  // const road_tCO2_passenger = passenger_year * (percent_passenger / 100) * vehicle_types["passenger"]["gCO2/km-passegner"] * km_year / 1e6;
  // const road_tCO2_taxi = passenger_year * (percent_taxi / 100) * vehicle_types["taxi"]["gCO2/km-passegner"] * km_year / 1e6;
  // const road_tCO2_tuktuk = passenger_year * (percent_tuktuk / 100) * vehicle_types["tuktuk"]["gCO2/km-passegner"] * km_year / 1e6;
  // const road_tCO2_pickuptruck = passenger_year * (percent_pickuptruck / 100) * vehicle_types["pickuptruck"]["gCO2/km-passegner"] * km_year / 1e6;
  // const road_tCO2_van = passenger_year * (percent_van / 100) * vehicle_types["van"]["gCO2/km-passegner"] * km_year / 1e6;
  // const road_tCO2_bus = passenger_year * (percent_bus / 100) * vehicle_types["bus"]["gCO2/km-passegner"] * km_year / 1e6;

   
  //  let road_tCO2_motorcycle = passenger_year * percent_motorcycle * vehicle_types["motorcycle"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_motorcycle = passenger_year * percent_motorcycle *  km_year / 1e6;
   console.log("road_tCO2_motorcycle",road_tCO2_motorcycle);

  //  let road_tCO2_passenger = passenger_year * percent_passenger * vehicle_types["passenger"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_passenger = passenger_year * percent_passenger * vehicle_types["passenger"]["gCO2/km-passegner"] * km_year / 1e6;
   console.log("road_tCO2_passenger",road_tCO2_passenger);

  //  let road_tCO2_taxi = passenger_year * percent_taxi * vehicle_types["taxi"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_taxi = passenger_year * percent_taxi * vehicle_types["taxi"]["gCO2/km-passegner"] * km_year / 1e6;
   console.log("road_tCO2_taxi",road_tCO2_taxi);

  //  let road_tCO2_tuktuk = passenger_year * percent_tuktuk * vehicle_types["tuktuk"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_tuktuk = passenger_year * percent_tuktuk * vehicle_types["tuktuk"]["gCO2/km-passegner"] * km_year / 1e6;
   console.log("road_tCO2_tuktuk",road_tCO2_tuktuk);

  //  let road_tCO2_pickuptruck = passenger_year * percent_pickuptruck * vehicle_types["pickuptruck"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_pickuptruck = passenger_year * percent_pickuptruck * vehicle_types["pickuptruck"]["gCO2/km-passegner"] * km_year / 1e6;
   console.log("road_tCO2_pickuptruck",road_tCO2_pickuptruck);

  //  let road_tCO2_van = passenger_year * percent_van * vehicle_types["van"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_van = passenger_year * percent_van * vehicle_types["van"]["gCO2/km-passegner"] * km_year / 1e6;
   console.log("road_tCO2_van",road_tCO2_van);

  //  let road_tCO2_bus = passenger_year * percent_bus * vehicle_types["bus"]["gCO2/km-passegner"] * km_year / 1e6;
   let road_tCO2_bus = passenger_year * percent_bus * vehicle_types["bus"]["gCO2/km-passegner"] * km_year / 1e6;
   console.log("road_tCO2_bus",road_tCO2_bus);



  results.road.tCO2 = road_tCO2_motorcycle + road_tCO2_passenger + road_tCO2_taxi + road_tCO2_tuktuk + road_tCO2_pickuptruck + road_tCO2_van + road_tCO2_bus;
  results.train.tCO2 = electricTrainData["tCO2/MWh"] * electrictrain_MWh_YEAR;
  results.reduce.tCO2 = results.road.tCO2 - results.train.tCO2;

  // Add calculations for other pollutants if available in your data structure
  // results.road.kgPM2 = ...
  // results.train.kgPM2 = ...

  console.log("--- ผลลัพธ์สุดท้ายที่คำนวณได้ (ใน cal_3_weight) ---");
  console.log("results:", results);
  console.log("----------------------------------------------------");

  return results;
}


